/**
 * Centro de Monitoreo del CM AI (R3.8) — datos agregados de seguimiento.
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api";

export interface MonitoringSummary {
  total: number;
  respondedByBot: number;
  respondedByHuman: number;
  pending: number;
  escalated: number;
  ignored: number;
}

export interface MonitoringInteraction {
  id: number;
  conversationId: string | null;
  externalUsername: string | null;
  kind: "dm" | "comment";
  platform?: string;
  body: string;
  state?: string;
  category?: string | null;
  motive?: string;
  reason?: string;
  escalatedTo?: string | null;
  receivedAt: string;
  zernioPostId?: string | null;
}

export interface MonitoringHistoryItem {
  id: number;
  conversationId: string | null;
  externalUsername: string | null;
  kind: "dm" | "comment";
  state: string;
  respondedBy: string | null;
  respondedAt: string | null;
  receivedAt: string;
  body: string;
  responseBody: string | null;
}

export interface MonitoringData {
  clientSlug: string;
  range: { from: string; to: string };
  tag: string | null;
  summary: MonitoringSummary;
  notResponded: MonitoringInteraction[];
  escalated: MonitoringInteraction[];
  history: MonitoringHistoryItem[];
  topics: Array<{ term: string; count: number }>;
}

export interface MonitoringFilters {
  from?: string;
  to?: string;
  tag?: string;
}

export function useMonitoring(
  clientSlug: string | undefined,
  filters: MonitoringFilters = {},
) {
  return useQuery<MonitoringData>({
    queryKey: ["monitoring", clientSlug, filters],
    enabled: !!clientSlug,
    queryFn: () => {
      const qs = new URLSearchParams({ clientSlug: clientSlug! });
      if (filters.from) qs.set("from", filters.from);
      if (filters.to) qs.set("to", filters.to);
      if (filters.tag) qs.set("tag", filters.tag);
      return apiGet<MonitoringData>(`/monitoring?${qs.toString()}`);
    },
  });
}
